// extracted by mini-css-extract-plugin
export default {"discord":"live-discord-module--discord--6fiE5","background":"live-discord-module--background--AE-60","iFrame":"live-discord-module--iFrame--plavK"};